import React from 'react';
import { Box, Typography } from '@mui/material';

// One shared "overline" section label, optionally with a trailing action
// (e.g. a "see all" button) — replaces the 4 near-identical local
// implementations that used to live in Community/Profile/Settings/Challenge.
export default function SectionTitle({ children, action, sx }) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        mt: 2,
        mb: 1,
        ...sx,
      }}
    >
      <Typography variant="overline" color="text.secondary">
        {children}
      </Typography>
      {action}
    </Box>
  );
}
